import { ShipmentDetailsModalProps } from 'lib/components/ShipmentDetailsModal/ShipmentDetailsModal'

// Mock OrderLeg data for Storybook stories
export const mockOrderLeg: OrderLeg = {
  leg_id: 'leg_ob_2024_001',
  leg_index: 0,
  pickup: true,
  leg_name: 'Outbound',
  pickup_fee_cents: 1500, // $15.00
  origin: {
    id: 'addr_nyc_001',
    address_1: '350 5th Ave',
    address_2: 'Suite 4200',
    city: 'New York',
    state: 'NY',
    zip: '10118',
    country: 'United States',
    country_code: 'US',
    phone_number: '+1-212-555-0123',
    company_name: 'Empire State Building',
    attention_name: 'Reception Desk',
    place: {
      name: 'Empire State Building',
      icon: '🏢',
    },
  },
  destination: {
    id: 'addr_la_001',
    address_1: '1600 Amphitheatre Parkway',
    city: 'Mountain View',
    state: 'CA',
    zip: '94043',
    country: 'United States',
    country_code: 'US',
    phone_number: '+1-650-555-0199',
    company_name: 'Google LLC',
    attention_name: 'Mail Room',
  },
  travelers: [
    {
      id: 'traveler_001',
      name: 'Sarah Johnson',
      email: 'sarah.johnson@example.com',
      phone: '+1-555-123-4567',
      sms: true,
      shipments: [
        {
          id: 'shipment_001',
          name: 'Business Documents Package',
          carrier_tracking_id: '1Z999AA1234567890',
          tracking_id: 'TRK_001_2024',
          ship_date: '03/15/2024',
          arrival_date: '03/17/2024',
          estimated_carrier_delivery_date: '03/17/2024',
          updated_at: 'March 15, 2024 09:45 AM',
          humanized_carrier_service_type: 'UPS Next Day Air',
          discount_cents: 500,
          wholesale_discount_cents: 0,
          upgrade_discount: 0,
          retail_ship_rate: 4500,
          clearance_fee_cents: 0,
          paid_insurance_cents: 200,
          handling_fee_cents: 300,
          fuel_surcharge_fee_cents: 150,
          total_price_cents: 4650,
          shipment_leg_name: 'Outbound',
          state: 'delivered',
          s3_label_url: 'https://labels.example.com/shipment_001.pdf',
          carrier_service_level: {
            id: 'ups_next_day',
            display_name: 'UPS Next Day Air',
            carrier: {
              code: 'UPS',
              system_name: 'ups',
              display_name: 'United Parcel Service',
            },
          },
          products: [
            {
              type: 'label',
              id: 'label_001',
              display_name: 'Laptop Computer',
              full_name: 'Apple MacBook Pro 16-inch',
              name: 'MacBook Pro',
              weight: 4.7,
              price_cents: 249900,
              packagingType: 'box',
              product_line: {
                id: 'electronics_001',
                display_name: 'Electronics',
              },
            },
            {
              type: 'insurance',
              id: 'insurance_001',
              coverage_amount_cents: 250000,
              product_line: {
                id: 'electronics_001',
                display_name: 'Electronics',
              },
            },
            {
              type: 'fee',
            },
          ],
        },
      ],
    },
    {
      id: 'traveler_002',
      name: 'Michael Chen',
      email: 'm.chen@example.com',
      phone: '+1-555-987-6543',
      sms: false,
      shipments: [
        {
          id: 'shipment_002',
          name: 'Photography Equipment',
          carrier_tracking_id: '1Z888BB9876543210',
          tracking_id: 'TRK_002_2024',
          ship_date: '03/15/2024',
          arrival_date: '03/18/2024',
          estimated_carrier_delivery_date: '03/18/2024',
          updated_at: 'March 15, 2024 10:30 AM',
          humanized_carrier_service_type: 'FedEx Ground',
          discount_cents: 0,
          wholesale_discount_cents: 200,
          upgrade_discount: 0,
          retail_ship_rate: 2800,
          paid_insurance_cents: 500,
          clearance_fee_cents: 0,
          handling_fee_cents: 250,
          fuel_surcharge_fee_cents: 100,
          total_price_cents: 3450,
          shipment_leg_name: 'Outbound',
          state: 'in_transit',
          carrier_service_level: {
            id: 'fedex_ground',
            display_name: 'FedEx Ground',
            carrier: {
              code: 'FEDEX',
              system_name: 'fedex',
              display_name: 'Federal Express',
            },
          },
          products: [
            {
              type: 'label',
              id: 'label_002',
              display_name: 'Camera Equipment',
              full_name: 'Canon EOS R5 Camera Kit',
              name: 'Canon R5 Kit',
              weight: 8.2,
              price_cents: 389900,
              packagingType: 'padded_case',
              product_line: {
                id: 'photography_001',
                display_name: 'Photography Equipment',
              },
            },
            {
              type: 'insurance',
              id: 'insurance_002',
              coverage_amount_cents: 400000,
              product_line: {
                id: 'photography_001',
                display_name: 'Photography Equipment',
              },
            },
            {
              type: 'fee',
            },
          ],
        },
      ],
    },
  ],
}

// Additional mock for Return leg
export const mockReturnOrderLeg: OrderLeg = {
  leg_id: 'leg_ret_2024_001',
  leg_index: 1,
  pickup: false,
  leg_name: 'Return',
  origin: {
    id: 'addr_la_001',
    address_1: '1600 Amphitheatre Parkway',
    city: 'Mountain View',
    state: 'CA',
    zip: '94043',
    country: 'United States',
    country_code: 'US',
    phone_number: '+1-650-555-0199',
    company_name: 'Google LLC',
    attention_name: 'Mail Room',
  },
  destination: {
    id: 'addr_nyc_001',
    address_1: '350 5th Ave',
    address_2: 'Suite 4200',
    city: 'New York',
    state: 'NY',
    zip: '10118',
    country: 'United States',
    country_code: 'US',
    phone_number: '+1-212-555-0123',
    company_name: 'Empire State Building',
    attention_name: 'Reception Desk',
    place: {
      name: 'Empire State Building',
      icon: '🏢',
    },
  },
  travelers: [
    {
      id: 'traveler_001',
      name: 'Sarah Johnson',
      email: 'sarah.johnson@example.com',
      phone: '+1-555-123-4567',
      sms: true,
      shipments: [
        {
          id: 'shipment_003',
          name: 'Return Package',
          carrier_tracking_id: '1Z777CC5555555555',
          tracking_id: 'TRK_003_2024',
          ship_date: '03/20/2024',
          arrival_date: '03/22/2024',
          estimated_carrier_delivery_date: '03/22/2024',
          updated_at: 'March 20, 2024 02:15 PM',
          humanized_carrier_service_type: 'UPS Ground',
          discount_cents: 300,
          wholesale_discount_cents: 0,
          upgrade_discount: 0,
          retail_ship_rate: 2200,
          paid_insurance_cents: 100,
          clearance_fee_cents: 0,
          handling_fee_cents: 200,
          fuel_surcharge_fee_cents: 80,
          total_price_cents: 2280,
          shipment_leg_name: 'Return',
          state: 'pending',
          carrier_service_level: {
            id: 'ups_ground',
            display_name: 'UPS Ground',
            carrier: {
              code: 'UPS',
              system_name: 'ups',
              display_name: 'United Parcel Service',
            },
          },
          products: [
            {
              type: 'label',
              id: 'label_003',
              display_name: 'Documents',
              full_name: 'Contract Documents & Reports',
              name: 'Business Documents',
              weight: 1.2,
              price_cents: 0,
              packagingType: 'envelope',
              product_line: {
                id: 'documents_001',
                display_name: 'Documents',
              },
            },
            {
              type: 'fee',
            },
          ],
        },
      ],
    },
  ],
}

export const mockCompleteOrder: Order = {
  id: 'order_2024_001',
  total_price_cents: 12580, // $125.80
  order_id: 'ORD-2024-MAR-001',
  state: 'completed',
  receipt_views: 3,
  device: 'web',
  user_id: 'user_12345',
  created_at: '2024-03-15T09:30:00Z',
  updated_at: '2024-03-17T14:45:00Z',
  user: {
    id: 'user_12345',
    first_name: 'Sarah',
    last_name: 'Johnson',
    email: 'sarah.johnson@example.com',
    phone_number: '+1-555-123-4567',
    has_temp_pass: false,
    country_code: 'US',
    club_name: 'Premium Business',
    vip: true,
    mobile_verification_eligible: true,
    mobile_verified: true,
    registered_device: 'iPhone 15 Pro',
    mobile_verified_date: '2024-01-15T10:00:00Z',
    customer_name: 'Sarah Johnson',
    lifetime_shipments: 47,
    terms_accepted: true,
    terms_version: '2.1',
    roles: ['customer', 'business_user'],
  },
  legs: [mockOrderLeg], // Use the leg we created earlier
  transactions: [
    {
      created_at: '2024-03-15T09:35:00Z',
      type: 'payment',
      transaction_id: 'txn_abc123def456',
      value: 12580,
      state: 'completed',
      payer_name: 'Sarah Johnson',
      payer_email: 'sarah.johnson@example.com',
      payment_method: {
        card_brand: 'Visa',
        last4: '4242',
        created_at: '2024-01-10T08:00:00Z',
        display_name: 'Visa ending in 4242',
      } as CreditCardPaymentMethod,
    },
  ],
}

export const blankShipmentPayload: Omit<ShipmentDetailsModalProps, 'id'> = {
  name: '',
  pickup_date: '',
  delivery_by: '',
  service: '',
  insurance_cents: 0,
  status: 'pending_shipment',
  shipper: 'fedex', // Required enum, using default
  origin: {
    address_1: '',
    city: '',
    state: '',
    zip: '',
    country: '',
  },
  destination: {
    address_1: '',
    city: '',
    state: '',
    zip: '',
    country: '',
  },
  updates: [],
  warning: undefined,
}
